
import { Component } from 'react'
import Post from '../../src/components/post'
import ComponentTree from '../../src/components/component-tree'
import components from '../../src/components/md-components'

export default (props) => {
  const data = {
  "layout": "post",
  "title": "A Thrill of Hope",
  "date": "2014-12-22 19",
  "comments": "true",
  "categories": "[\"recording\", \"christmas\"]",
  "draft": true,
  "path": "pages/posts/undefined.js",
  "permalink": "posts/undefined",
  "created": "2014-12-22",
  "tags": [
    "recording",
    "christmas"
  ]
}
  const body = {"type":"div","props":{},"children":[{"type":"p","props":{},"children":["On December 6th, the St. Augustine Chamber Choir hosted our annual concert to prepare for Christmas. Today, the entire show is available to stream and ",{"type":"a","props":{"href":"https://www.dropbox.com/s/45xhimnv0jh14t6/athrillofhope.zip"},"children":["download (mp3, 114 MB)"]},"."]},"\n",{"type":"iframe","props":{"width":"100%","height":750,"scrolling":"no","frameborder":"no","src":"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/65587528&color=c81d1d&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false"}}]}
  return (
    <Post {...data}>
      <ComponentTree {...body} components={components} />
    </Post>
  )
}
